/**
 * Midpoint brand fill for organisation logo empty states (not user avatars).
 *
 * Single fill halfway between chrome navy (`--primary-dark`) and control primary (`--primary`)
 * via `color-mix` in oklch (collapses cleanly when tokens coincide, e.g. dark theme).
 *
 * Pair with `--primary-foreground`; swap if contrast fails on a tenant.
 */
export const PROFILE_INITIALS_AVATAR_SURFACE_CLASS =
  "bg-[color-mix(in_oklch,var(--primary-dark)_50%,var(--primary))] text-primary-foreground"

/** Same midpoint brand fill as {@link PROFILE_INITIALS_AVATAR_SURFACE_CLASS} — org logo empty states. */
export const ORG_LOGO_PLACEHOLDER_SURFACE_CLASS = PROFILE_INITIALS_AVATAR_SURFACE_CLASS
